module.exports = __webpack_public_path__ + "img/piso-enfermagem.631e1c4a.png";